import msalInstance from '../components/entra/msalInstance';
import { accessTokenRequest } from '../entraConfig';

export default async function getAccessToken() {
  const account = msalInstance.getActiveAccount();
  if (!account) {
    throw new Error('not logged in');
  }

  const request = {
    ...accessTokenRequest,
    account,
  };

  const response = await msalInstance.acquireTokenSilent(request);
  return response.accessToken;
}
